import { api } from "../utils/AuthManager";

const PostPaymentLink = async (id) => {
  return api
    .post(`/api/payment_link/${id}/`)

    .then((res) => {
      return res;
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

export default PostPaymentLink;
